<template>
    <div class="container-fluid">
        <Loading v-if="!loaded"></Loading>
        <div v-else>
            <!-- TITLE -->
            <div class="mt-2 tabName">
                <h3>{{ $t('edit_reservation') }}</h3>
            </div>
            <!-- RESERVATION FORM -->
            <ReservationForm
                :errors="errors"
                :reservation="reservation"
                :showAddMedicationInitially="false"
                :showAmountEditorInitially="true"
                submitButtonName="update_reservation"
                @submit="submitReservationForm"
                :key="formKey"
            />
            <modals-container />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import Loading from '@/views/partial/Loading';
import { getReservation, handleAxiosError, updateReservation } from '@/services/axiosService';
import { combineReservations } from '@/services/reservationService';
import ReservationForm from './ReservationForm';

export default {
    components: {
        Loading,
        ReservationForm
    },
    data() {
        return {
            errors: {},
            formKey: 0,
            loaded: false,
            reservation: {}
        };
    },
    async created() {
        // get reservation
        await this.getReservation();
        this.loaded = true;
    },
    methods: {
        ...mapActions('account', ['logout']),
        // get reservation with res_id provided in route parameter
        async getReservation() {
            try {
                const reservations = await getReservation(this.$route.params.res_id);
                this.reservation = combineReservations(reservations);
            } catch (error) {
                handleAxiosError(error);
            }
        },
        // submit reservation form (update reservation, show notification and redirect to index)
        async submitReservationForm() {
            try {
                await updateReservation(this.reservation);
                this.$toastr.s(this.$t('reservation_updated'));
                this.$router.push({ name: 'reservation.index' });
            } catch (error) {
                handleAxiosError(error);
                // if backend returns 409 (duplicate) error, show error message under prescription field
                if (error.response.data.status === 409) {
                    this.errors['prescription'] = error.response.data.message;
                }
                this.formKey = this.formKey + 1; // update form key for component refresh
            }
        }
    }
};
</script>

<style>
.custom_ul {
    border: 1px solid #ced4da;
    padding-left: 10px;
    list-style: none;
}
.custom_ul li {
    cursor: pointer;
    line-height: 30px;
}
.custom_ul li:hover {
    color: blue;
}
</style>
